import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { posts } from '../data/posts';
import Seo from '../components/seo';
import styles from '../styles/Blog.postdetails.module.css';

export default function PostDetail() {
  const { id } = useParams();
  
  // CRITICAL: This finds the specific post based on the URL ID
  const post = posts.find((p) => p.id === id);

  useEffect(() => { 
    window.scrollTo(0, 0); 
  }, [id]);

  if (!post) {
    return (
      <div className="container py-5 mt-5 text-center">
        <h1 className="mb-4">Post Not Found</h1>
        <Link to="/blog" className="btn-primary-ie">Back to Feed</Link>
      </div>
    );
  }

  return (
    <main className={styles.page}>
      <Seo title={`${post.title} | InviteEngine`} description={post.excerpt} path={`/blog/${id}`} />

      {/* ─── EDITORIAL HERO ─── */}
      <section className={styles.hero}>
        <div className="container text-center">
          <Link to="/blog" className={styles.backBtn}>← Back to Insights</Link>
          <div className={styles.metaRow}>
            <span>{post.date}</span>
            <span className={styles.dot}>•</span>
            <span>{post.readTime}</span>
          </div>
          <h1 className={styles.mainTitle}>{post.title}</h1>
        </div>
      </section>

      {/* ─── CONTENT AREA ─── */}
      <section className={styles.contentSection}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9 col-xl-8">
              
              <article className={styles.articleBody}>
                {post.sections.map((sec, i) => {
                  switch (sec.type) {
                    case 'intro': 
                      return <p key={i} className={styles.authorName}>{sec.content}</p>;
                    
                    case 'h2': 
                      return <h2 key={i} className={styles.heading2}>{sec.content}</h2>;
                    
                    case 'h3': 
                      return <h3 key={i} className={styles.heading3}>{sec.content}</h3>;
                    
                    case 'p': 
                      return <p key={i} className={styles.paragraph}>{sec.content}</p>;

                    case 'hr': 
                      return <hr key={i} className={styles.divider} />;

                    case 'list': 
                      return (
                        <ul key={i} className={styles.bulletList}>
                          {sec.items.map((item, idx) => (
                            <li key={idx} className={styles.listItem}>{item}</li>
                          ))}
                        </ul>
                      );

                    case 'quote': 
                      return (
                        <blockquote key={i} className={styles.quoteBlock}>
                          <p>"{sec.content}"</p>
                          <footer>— {sec.author}</footer>
                        </blockquote>
                      );
                    
                    case 'grid-feature': 
                      return (
                        <div key={i} className={styles.stepsSection}>
                          <h4 className={styles.gridTitle}>{sec.title}</h4>
                          <div className={styles.stepsGrid}>
                            {sec.items.map((item, idx) => (
                              <div key={idx} className={styles.stepCard}>
                                <div className={styles.stepBadge}>{item.num}</div>
                                <h5 className={styles.stepLabel}>{item.label}</h5>
                                <p className={styles.stepDesc}>{item.desc}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                      );
                    
                    default: return null;
                  }
                })}
              </article>

            </div>
          </div>
        </div>
      </section>
    </main>
  );
}